// Public pages are cached and never read the session cookie, so the header
// can't know who is signed in. The server sets a readable `karou_signed_in=1`
// cookie next to the httponly session cookie and deletes it on sign out; the
// header reads it and swaps the links marked data-account-link. It grants
// nothing: /app still checks the real session and sends a stale hint to /login.
export const HINT_COOKIE = 'karou_signed_in'

// The localStorage key an earlier version used; cleared once on load.
const OLD_HINT_KEY = 'karou:signed-in'

export function isSignedIn(cookie: string = document.cookie): boolean {
  return cookie.split(';').some((part) => part.trim() === `${HINT_COOKIE}=1`)
}

// <a data-account-link data-signed-in-href="/app" data-signed-in-label="My library">Sign in</a>
// <a data-signed-out-only>Sign in</a> is hidden once signed in (the CTA already opens the app).
export function applySessionHint(root: ParentNode = document, cookie: string = document.cookie): void {
  if (!isSignedIn(cookie)) return
  root.querySelectorAll<HTMLElement>('[data-signed-out-only]').forEach((el) => (el.hidden = true))
  root.querySelectorAll<HTMLAnchorElement>('[data-account-link]').forEach((link) => {
    link.href = link.dataset.signedInHref ?? '/app'
    link.textContent = link.dataset.signedInLabel ?? 'My library'
  })
}

export function clearOldHint(): void {
  try {
    window.localStorage.removeItem(OLD_HINT_KEY)
  } catch {
    /* blocked storage: nothing to clear */
  }
}
